import { Component, Input } from '@angular/core';
import { ElementComponent } from 'tuain-ng-forms-lib';
import { componentConstants } from 'src/app/components/tuain/forms.module.config';

const LOCATION = 'location';
@Component({
  selector: 'app-element',
  templateUrl: './app-element.component.html',
})

export class AppElementComponent extends ElementComponent {
  location: string;
  componentConstants: any;
  @Input() layout = 'inline';

  constructor() {
    super();
    this.componentConstants = { ...componentConstants };
  }

  override start() {
    super.start();
    this.location = this.element.getCustomAttribute(LOCATION);
  }
}
